import axios from 'axios';
import { AdresseIP } from './AdresseIp';


export class CouloirService {

    constructor(){
        this.adresse = new AdresseIP()
    }
    
    getAll() {
        
        return axios.get(this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/couloir')
                    .then(res => res.data);
    }
    create(newCouloir) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/couloir'
        return axios.post(url,newCouloir)
                    .then(res => res.data);
    }
    update(idCouloir ,newCouloir) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/couloir/'
        return axios.put(url+idCouloir, newCouloir)
                    .then(res => res.data);
    }
    delete(idCouloir) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/couloir/'
        return axios.patch(url+idCouloir)
                    .then(res => res.data)
    }
    get(idNiveau) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/couloir/?idNiveau='+idNiveau
        return axios.get(url)
                    .then(res => res.data)
    }

}